import { useLayoutEffect, useEffect, useState } from 'react';
import { useApiKey } from '../state';
import * as sdk from 'fetchfox-sdk';

import { GlobalContext } from '../context/GlobalContext';

export const GlobalProvider = ({ children }) => {
  const [apiKey, setApiKey] = useApiKey();
  // const user_ = useUser();
  const [fox, setFox] = useState();
  const [user, setUser] = useState();
  const [host, setHost] = useState();
  const [isDev, setIsDev] = useState(false);

  useLayoutEffect(() => {
    try {
      console.log('window.location.origin', window.location.origin);
      setIsDev(window.location.origin.includes('localhost') || window.location.origin.includes('dev.app.fetchfox.ai'));
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    console.log('Using API key:', apiKey, sdk);

    if (apiKey) {
      sdk.configure({ apiKey });
      setFox(sdk);
      setHost(sdk.host());
    } else {
      setFox(null);
    }
  }, [apiKey]);

  useEffect(() => {
    setUser(null);
    if (!fox) {
      return;
    }
    fox.user.get().then(setUser);
  }, [fox]);

  const refreshUser = () => fox.user.get().then(setUser);

  return (
    <GlobalContext.Provider value={{ apiKey, setApiKey, user, refreshUser, fox, host, isDev }}>
      {children}
    </GlobalContext.Provider>
  );
};
